import React, { useState, useCallback, useEffect } from 'react'
import { Flex } from 'reflexbox'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { demandsMutations } from '../../graphql/mutations'
import { demandsQueries } from '../../graphql/queries'
import graphqlHelpers from 'ui-components/lib/helpers/graphql'
import useAlertStack from 'ui-components/lib/hooks/useAlertStack'
import useSearchTerm from 'ui-components/lib/hooks/useSearchTerm'
import "./Proposals.css";

import AcceptModal from '../../components/Modal/Proposals/AcceptModal'
import RefuseModal from '../../components/Modal/Proposals/RefuseModal'
import SuccessModal from '../../components/Modal/Proposals/SuccessModal'
import DemandDetails from '../../components/Modal/Proposals/DemandDetails'
import ChatDemand from '../../components/ChatDemand'
import Breadcumb from 'ui-components/lib/components/BreadCrumb'

import {
  CustomTableProposals
} from '../../components'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'


const Proposals = (props) => {
  const { showMessage } = useAlertStack()
  const [currentPage, setCurrentPage] = useState(1)
  const [sort] = useState('code')
  const [order] = useState('desc')
  const [openAcceptModal, setOpenAcceptModal] = useState(false)
  const [openRefuseModal, setOpenRefuseModal] = useState(false)
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [openDemandDetailsModal, setOpenDemandDetailsModal] = useState(false)
  const [openChatModal, setOpenChatModal] = useState(false);
  const [demandIdProposal, setDemandIdProposal] = useState('');
  const [demandLawyerChatModal, setDemandLawyerChatModal] = useState('');
  const { push } = useHistory()

  const [demandBidId, setDemandBidId] = useState('');
  const [acceptDemandBidId, setAcceptDemandBidId] = useState('');
  const [refuseDemandBidId, setRefuseDemandBidId] = useState('');

  const [modalType, setModalType] = useState('')
  const [searchTerm, lazySearchTerm, { handleChangeSearchTerm }] = useSearchTerm('', 400)
  const [filtersOpen, setFiltersOpen] = useState(false)
  const [offset] = useState(10)

  const { loading: demandsLoading, data: demandsData, refetch: refetchDemands } = useQuery(demandsQueries.GET_DEMANDS, {
    variables: {
      search: lazySearchTerm,
      sort: sort,
      page: currentPage,
      order: order,
      offset: offset,
      queryBy: 'status',
      isAuction: true
    },
  })

  useEffect(() => {
    refetchDemands()
  }, [refetchDemands, lazySearchTerm])

  const [approveDemandBid, { loading: approveDemandBidLoading }] = useMutation(demandsMutations.APPROVE_DEMAND_BID, {
    variables: {
      bidId: acceptDemandBidId,
    },
    onCompleted() {
      setOpenDemandDetailsModal(false)
      setOpenAcceptModal(false)
      handleOpenSuccessModal('bidAccepted')
      refetchDemands()
    },
    // refetchQueries: [
    //   {
    //     query: demandsQueries.GET_DEMAND,
    //     variables: { id },
    //   },
    //   {
    //     query: walletQueries.GET_MY_WALLET,
    //   },
    // ],
    update: graphqlHelpers.deleteItemsFromCache('Demands'),
    onError({ graphQLErrors }) {
      setOpenAcceptModal(false)
      showMessage({
        title: 'Erro ao aceitar a proposta',
        message: graphQLErrors[0]?.extensions?.response?.body?.message || 'Tente novamente mais tarde.',
        color: 'danger',
        position: 'bottom-left',
        time: 4000,
      })
    },
  })

  const [reproveDemandBid, { loading: reproveDemandBidLoading }] = useMutation(demandsMutations.REPROVE_DEMAND_BID, {
    variables: {
      bidId: refuseDemandBidId,
    },
    onCompleted() {
      setOpenDemandDetailsModal(false)
      setOpenRefuseModal(false)
      handleOpenSuccessModal('bidRefused')
      refetchDemands()
    },
    // refetchQueries: [
    //   {
    //     query: demandsQueries.GET_DEMAND,
    //     variables: { id },
    //   },
    // ],
    update: graphqlHelpers.deleteItemsFromCache('Demands'),
    onError() {
      setOpenRefuseModal(false)
      showMessage({
        title: 'Erro ao reprovar a proposta',
        message: 'Tente novamente mais tarde.',
        color: 'danger',
        position: 'bottom-left',
        time: 4000,
      })
    },
  })

  const handleChangePrev = () => {
    const prevPage = currentPage - 1
    if (prevPage > 0) {
      setCurrentPage(currentPage - 1)
    }
  }

  const handleChangeNext = () => {
    const nextPage = currentPage + 1
    if (nextPage <= demandsData?.listDemands?.pagination?.pagesAmount) {
      setCurrentPage(nextPage)
    }
  }

  const handleOpenDemandDetailsModal = useCallback((demandId, demandBid) => {
    setDemandBidId(demandBid)
    setDemandIdProposal(demandId)
    setOpenDemandDetailsModal(!openDemandDetailsModal)
  }, []) //eslint-disable-line

  const handleOpenAcceptModal = useCallback((id) => {
    setAcceptDemandBidId(id)
    setOpenDemandDetailsModal(false)
    setOpenAcceptModal(!openAcceptModal)
  }, []) //eslint-disable-line

  const handleOpenRefuseModal = useCallback((id) => {
    setRefuseDemandBidId(id)
    setOpenDemandDetailsModal(false)
    setOpenRefuseModal(!openRefuseModal)
  }, []) //eslint-disable-line

  const handleOpenSuccessModal = useCallback((type) => {
    setModalType(type)
    setOpenSuccessModal(!openSuccessModal)
  }, []) //eslint-disable-line

  const handleChatModal = useCallback(({demandId, demandLawyer}) => {
    setDemandIdProposal(demandId)
    setDemandLawyerChatModal(demandLawyer)
    setOpenChatModal(!openChatModal)
  }, []) //eslint-disable-line

  const handleAcceptDemandBid = useCallback(() => {
    approveDemandBid()
  }, []) //eslint-disable-line

  const handleRefuseDemandBid = useCallback(() => {
    reproveDemandBid()
  }, []) //eslint-disable-line

  
  const breadcrumbLinks = [
    { label: 'Início', onClick: () => push('/dashboard') },
    { label: 'Serviços', onClick: () => push('/dashboard/serviços') },
    { label: 'Propostas' },
  ]

  return (
    <>
      <Flex width={1} justifyContent="center" flexDirection="column" className="service">
        <Flex width={1} mb={3} className="breadCrumb">
          <Breadcumb ml={-3} color="primary" navigationLinks={breadcrumbLinks} />
        </Flex>
      </Flex>
      <div className="proposals-page-container">
        <div className="proposals-page-wrapper">
          {/* Header Section */}
          <div className="proposals-page-header">
            <div className="proposals-header-content">
              <div>
                <h1 className="proposals-page-title">Minhas Propostas</h1>
                <p className="proposals-page-subtitle">
                  Visualize e gerencie todas as propostas de serviços jurídicos recebidas.
                </p>
              </div>
              <div className="proposals-header-actions">
                <button 
                  className="proposals-filters-toggle"
                  onClick={() => setFiltersOpen(!filtersOpen)}
                  type="button"
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="16" 
                    height="16" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    style={{ transform: filtersOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                  <span>Filtros</span>
                </button>
              </div>
            </div>
          </div>

          {/* Collapsible Filters Section */}
          {filtersOpen && (
            <div className="proposals-filters-section">
              <div className="proposals-search-wrapper">
                <label className="proposals-filter-label" htmlFor="search">Buscar proposta</label>
                <div className="proposals-search-input-wrapper">
                  <svg 
                    className="proposals-search-icon" 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                  </svg>
                  <input
                    id="search"
                    name="search"
                    type="text"
                    placeholder="Buscar por proposta..."
                    value={searchTerm}
                    onChange={(event) => handleChangeSearchTerm(event.target.value)}
                    className="proposals-search-input"
                  />
                </div>
              </div>
            </div>
          )}

          {/* Table Section */}
          <div className="proposals-table-container">
            <div className="proposals-table-wrapper">
            <CustomTableProposals
              loading={demandsLoading}
              data={demandsData?.listDemands?.data}
              headers={[
                {title: 'Número'},
                {title: 'Serviço'},
                {title: 'Prazo'},
                {title: 'Valor'},
                {title: 'Ações'}
              ]}
              changePage={(item) => setCurrentPage(item)}
              prevPage={() => handleChangePrev()}
              nextPage={() => handleChangeNext()}
              totalPages={demandsData?.listDemands?.pagination?.pagesAmount}
              page={currentPage}
              refuseModal={handleOpenRefuseModal}
              acceptModal={handleOpenAcceptModal}
              demandModal={handleOpenDemandDetailsModal}
            />
            </div>
          </div>
          <DemandDetails 
            openModal={openDemandDetailsModal}
            handleClose={() => setOpenDemandDetailsModal(false)}
            loading={demandsLoading}
            demandId={demandIdProposal}
            demandBidId={demandBidId}
            handleOpenChat={handleChatModal}
            handleOpenAcceptModal={handleOpenAcceptModal}
            handleOpenRefuseModal={handleOpenRefuseModal}
          />
          <AcceptModal 
            openModal={openAcceptModal}
            handleClose={() => setOpenAcceptModal(false)}
            action={handleAcceptDemandBid}
            loading={approveDemandBidLoading}
          />
          <RefuseModal 
            openModal={openRefuseModal}
            handleClose={() => setOpenRefuseModal(false)}
            action={handleRefuseDemandBid}
            loading={reproveDemandBidLoading}
          />
          <SuccessModal 
            openModal={openSuccessModal}
            handleClose={() => setOpenSuccessModal(false)}
            modalType={modalType}
          />
          <ChatDemand
            handleClose={() => setOpenChatModal(false)}
            openModal={openChatModal}
            demandId={demandIdProposal}
            demandLawyer={demandLawyerChatModal}
          />
        </div>
      </div> 
    </>
  )
}

export default Proposals
